import { getTableType } from '@/entities/chart/lib/get-table-type';
import { v1ApiClient } from '@/services';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { tableDataConverter } from './converter';
import type { CreateChartPayload } from './types';

export const fetchChartTable = async (
  chartState: CreateChartPayload,
): Promise<ChartTableRes> => {
  const wa = getCurrWorkspaceAlias();
  const res = await v1ApiClient.post(
    `/workspaces/${wa}/charts/table`,
    chartState,
  );

  const tableType = getTableType(
    chartState.type,
    !!chartState.historical?.value,
  );

  return tableDataConverter(res.data, tableType) as ChartTableRes;
};
